import VZRangeSlider from './VZRangeSlider';

export default class VZBundleSelectorSlider extends VZRangeSlider {
    constructor() {
        super();
    }

    /**
     * @function initializeElements
     * @description Initialize all DOM elements and component properties
     */
    initializeElements() {
        super.initializeElements();

        // Slider Type & Identifier
        this.sliderIdentifier = this.getAttribute('data-slider-identifier') || null;

        // Select and Options
        this.triggerSelect = this.querySelector('.js-range-slider-select');
        this.selectOptions = Array.from(this.querySelectorAll('option'));
        this.selectOptionsDefault = this.querySelector('option[default]');

        // Price Container
        this.priceContainer = this.querySelector('.js-range-slider-select-price');
    }

    /**
     * @function setupEventListeners
     * @description Set up all event listeners
     */
    setupEventListeners() {
        super.setupEventListeners();

        if (this.triggerSelect) {
            this.boundSelectChange = this.onSelectChange.bind(this);
            this.triggerSelect.addEventListener('change', this.boundSelectChange);
        }
    }

    /**
     * @function removeEventListeners
     * @description Remove all event listeners
     */
    removeEventListeners() {
        super.removeEventListeners();
        if (this.triggerSelect) this.triggerSelect.removeEventListener('change', this.boundSelectChange);
    }

    /**
     * @function initSlider
     * @description Initialize the slider with default values
     */
    initSlider() {
        if (this.selectOptionsDefault) {
            const sliderValue = this.selectOptionsDefault.getAttribute('data-index-value');
            const priceValue = this.selectOptionsDefault.getAttribute('data-formatted-price');

            this.updateValue(sliderValue);

            if (this.priceContainer) {
                this.priceContainer.innerHTML = priceValue;
            }
        }
    }

    /**
     * @function onInputChange
     * @description Handle input changes
     * @param {Event} evt - The input event
     */
    onInputChange(evt) {
        super.onInputChange(evt);

        const selectChangeEvent = new CustomEvent('customSelectChange', {
            detail: {
                selectedIndex: parseInt(evt.target.value, 10)
            }
        });

        this.onSelectChange(selectChangeEvent);
    }

    /**
     * @function onSelectChange
     * @description Handle selection changes
     * @param {Event} evt - The select change event
     */
    onSelectChange(evt) {
        const force = evt.detail ? evt.detail.force : false; // Optional flag to check for
        const selectedIndex = evt.detail ? evt.detail.selectedIndex : evt.target.selectedIndex;
        const selected = this.triggerSelect.options[selectedIndex];

        // Update Select
        const newSelectedValue = parseInt(selected.value, 10);
        if (this.triggerSelect.value !== newSelectedValue) this.triggerSelect.value = newSelectedValue;

        // Update Input
        const newInputValue = parseInt(selected.getAttribute('data-index-value'), 10);
        if (this.triggerInput.value !== newInputValue) this.updateValue(newInputValue);

        // Update UI
        this.updateUI(selected);
        this.dispatchBundleUpdate(selected, force);
    }

    /**
     * @function updateUI
     * @description Update UI elements with new values
     * @param {HTMLOptionElement} selected - The selected option element
     */
    updateUI(selected) {
        const priceValue = selected.getAttribute('data-formatted-price');
        super.updatePriceDisplay({
            formattedPrice: priceValue
        });
    }

    /**
     * @function dispatchBundleUpdate
     * @description Dispatch bundle update event
     * @param {HTMLOptionElement} selected - The selected option element
     * @param {boolean} force - Optional param to force an action elsewhere
     */
    dispatchBundleUpdate(selected, force = false) {
        const updateEvent = new CustomEvent('vzbundleselectorslider:update', {
            bubbles: true,
            detail: {
                identifier: this.sliderIdentifier,
                selected,
                force
            }
        });

        this.dispatchEvent(updateEvent);
    }
}

if (!window.customElements.get('vz-bundle-selector-slider')) {
    window.customElements.define('vz-bundle-selector-slider', VZBundleSelectorSlider);
}
